/* eslint-disable no-shadow */
import moment from 'moment';

const state = {
	expiration: moment().add(1, 'hour').unix(),
	tags: {
		loading: false,
		types: ['group', 'category', 'brand', 'store', 'hashtag'],
		orderBy: 'deals',
		users: {
			results: [],
			total: 0,
		},
		deals: {
			results: [],
			total: 0,
		},
	},
	posts: {
		loading: false,
		total: 0,
		popular: {
			dates: [moment().startOf('days').format(), moment().format()],
			results: [],
		},
	},
	comments: 0,
	users: {
		loading: false,
		total: 0,
		stats: {
			dates: [moment().startOf('year').format(), moment().format()],
			results: [],
		},
	},
	popularUsers: {
		loading: false,
		results: [],
	},
	aliexpressSales: {
		loading: false,
		totalComision: 0,
		results: [],
		inDates: {
			totalComision: 0,
			total: 0,
		},
		query: {
			search: '',
			dates: [],
			limit: 12,
			order_by: 'CompletedPaymentsTime',
			order_mode: '',
		},
		stats: {
			dates: [moment().startOf('year').format(), moment().format()],
			results: [],
			loading: false,
		},
		tops: {
			results: [],
			loading: false,
			query: {
				date: '24h',
			},
		},
	},
};

const getters = {
	'stats/tags': st => st.tags,
	'stats/posts': st => st.posts,
	'stats/comments': st => st.comments,
	'stats/users': st => st.users,
	'stats/popularUsers': st => st.popularUsers,
	'stats/aliexpressSales': st => st.aliexpressSales,
};

const mutations = {
	// TAGS
	SET_TAG_LOADING(state, value) {
		state.tags.loading = value;
	},
	SET_TAG_STATS(state, { scope, value }) {
		state.tags[scope] = value;
	},
	SET_TAG_TYPES(state, value) {
		state.tags.types = value;
	},
	SET_TAG_ORDERBY(state, value) {
		state.tags.orderBy = value;
	},
	// POSTS
	SET_POSTS_LOADING(state, value) {
		state.posts.loading = value;
	},
	SET_POSTS_TOTAL(state, value) {
		state.posts.total = value;
	},
	SET_POSTS_DATES(state, value) {
		state.posts.popular.dates = value;
	},
	DEL_POSTS_POPULAR(state, index) {
		state.posts.popular.results.splice(index, state.posts.popular.results.length);
	},
	ADD_POSTS_POPULAR(state, data) {
		state.posts.popular.results = data;
	},
	SET_POSTS_POPULAR(state, { value }) {
		state.posts.popular.results = value;
	},
	// USERS
	SET_USERS_LOADING(state, value) {
		state.users.loading = value;
	},
	SET_USERS_TOTAL(state, value) {
		state.users.total = value;
	},
	SET_USERS_DATES(state, value) {
		state.users.stats.dates = value;
	},
	SET_USERS_STATS(state, value) {
		state.users.stats.results = value;
	},
	// POPULAR USERS
	SET_POPULAR_USERS_LOADING(state, value) {
		state.popularUsers.loading = value;
	},
	SET_POPULAR_USERS_STATS(state, value) {
		state.popularUsers.results = value;
	},
	DEL_POPULAR_USERS(state) {
		state.popularUsers.results = [];
	},
	// COMMENTS
	SET_COMMENTS_STATS(state, value) {
		state.comments = value;
	},
	// Aliexpress Sales
	SET_ALIEXPRESS_SALES(state, value) {
		state.aliexpressSales.results = value;
	},
	ADD_ALIEXPRESS_SALES(state, value) {
		state.aliexpressSales.results = value;
	},
	SET_ALIEXPRESS_SALES_QUERY(state, value) {
		state.aliexpressSales.query = value;
	},
	SET_ALIEXPRESS_SALES_LOADING(state, value) {
		state.aliexpressSales.loading = value;
	},
	SET_ALIEXPRESS_SALES_TOTAL_COMISION(state, value) {
		state.aliexpressSales.totalComision = value;
	},
	SET_ALIEXPRESS_SALES_IN_DATES(state, value) {
		state.aliexpressSales.inDates = value;
	},
	SET_ALIEXPRESS_SALES_STATS(state, value) {
		state.aliexpressSales.stats.results = value;
	},
	SET_ALIEXPRESS_SALES_STATS_DATES(state, value) {
		state.aliexpressSales.stats.dates = value;
	},
	SET_ALIEXPRESS_SALES_STATS_LOADING(state, value) {
		state.aliexpressSales.stats.loading = value;
	},
	SET_ALIEXPRESS_TOPS(state, value) {
		state.aliexpressSales.tops.results = value;
	},
	SET_ALIEXPRESS_TOPS_QUERY(state, value) {
		state.aliexpressSales.tops.query = value;
	},
	SET_ALIEXPRESS_TOPS_LOADING(state, value) {
		state.aliexpressSales.tops.loading = value;
	},
	// CLEAR ALL
	CLEAR_ALL_STATS(state) {
		state.tags = {
			loading: false,
			types: ['group', 'category', 'brand', 'store', 'hashtag'],
			orderBy: 'deals',
			users: {
				results: [],
				total: 0,
			},
			deals: {
				results: [],
				total: 0,
			},
		};

		state.posts = {
			loading: false,
			total: 0,
			popular: {
				dates: [moment().startOf('days').format(), moment().format()],
				results: [],
			},
		};

		state.comments = 0;

		state.users = {
			loading: false,
			total: 0,
			stats: {
				dates: [moment().startOf('year').format(), moment().format()],
				results: [],
			},
		};
	},
};

const actions = {
	// TAGS
	async loadTagStats({ commit, state }, reset = false) {
		commit('SET_TAG_LOADING', true);

		let { types } = state.tags;
		if (types === 0) types = ['group', 'category', 'brand', 'store', 'hashtag'];

		const { orderBy } = state.tags;
		if (reset || state.tags[orderBy].results.length === 0) {
			const tagsUser = await this.$sdk.admin().stats.tags({ limit: 10, order_by: orderBy, type: types.join(',') });
			if (tagsUser.ok) commit('SET_TAG_STATS', { scope: orderBy, value: tagsUser.data });
		}

		commit('SET_TAG_LOADING', false);
	},
	setTagStatsTypes({ commit, dispatch }, value) {
		commit('SET_TAG_TYPES', value);
		dispatch('loadTagStats', true);
	},
	setTagOrder({ commit, dispatch }, value) {
		commit('SET_TAG_ORDERBY', value);
		dispatch('loadTagStats');
	},
	// POSTS
	async loadPostStats({ commit, state }, reset = false) {
		commit('SET_POSTS_LOADING', true);


		if (reset || state.posts.popular.results.length === 0) {
			const popularPosts = await this.$sdk.deals().list({ start_time: state.posts.popular.dates[0], end_time: state.posts.popular.dates[1], order_by: 'popularity', offset: 0, limit: 12 });

			let results = [];
			if (popularPosts.ok) ({ results } = popularPosts.data);

			if (reset) commit('DEL_POSTS_POPULAR');
			commit('ADD_POSTS_POPULAR', results);
			commit('SET_POSTS_TOTAL', popularPosts.data.total);
		}

		commit('SET_POSTS_LOADING', false);
	},
	setPostStatsDates({ commit, dispatch }, value) {
		commit('SET_POSTS_DATES', value);
		dispatch('loadPostStats', true);
	},
	// USERS
	async loadUserStats({ commit, state }, reset = false) {
		commit('SET_USERS_LOADING', true);

		if (reset || state.users.total === 0) {
			const users = await this.$sdk.admin().users.list({ offset: 0, limit: 1 });
			if (users.ok) commit('SET_USERS_TOTAL', users.data.total);
		}

		if (reset || state.users.stats.results.length === 0) {
			const registers = await this.$sdk.admin().stats.registers({ offset: 0, limit: 365 });
			if (registers.ok) {
				const series = [];
				registers.data.forEach((item) => {
					series.push({ x: new Date(item.date).getTime(), y: parseInt(item.count, 10) });
				});

				commit('SET_USERS_STATS', series);
			}
		}

		commit('SET_USERS_LOADING', false);
	},
	setUsersStatsDates({ commit }, value) {
		commit('SET_USERS_DATES', value);
		// dispatch('loadUserStats', true);
	},
	// COMMENTS
	async loadCommentStats({ commit, state }, reset = false) {
		if (reset || state.comments === 0) {
			const comments = await this.$sdk.admin().comments.list(0, 1);
			if (comments.ok) commit('SET_COMMENTS_STATS', comments.data.total);
		}
	},
	// POPULAR USERS
	async loadUserPostStats({ commit, state }, reset = false) {
		commit('SET_POPULAR_USERS_LOADING', true);

		if (reset || state.popularUsers.results.length === 0) {
			const popularPosts = await this.$sdk.deals().list({ order_by: 'popularity', offset: 0, limit: 50 });

			let results = [];

			if (popularPosts.ok) {
				const users = [];
				popularPosts.data.results.forEach((p) => {
					const find = users.findIndex(u => u.user.id === p.user.id);
					if (find === -1) users.push(p);
				});

				results = users.slice(0, 10);
			}

			if (reset) commit('DEL_POPULAR_USERS');
			commit('SET_POPULAR_USERS_STATS', results);
		}

		commit('SET_POPULAR_USERS_LOADING', false);
	},
	// ALIEXPRESS SALES
	// eslint-disable-next-line no-unused-vars
	async loadAliexpressSales({ commit }, value) {
		commit('SET_ALIEXPRESS_SALES_LOADING', true);
		setTimeout(() => {
			commit('SET_ALIEXPRESS_SALES_LOADING', false);
		}, 1000);
	},
	// eslint-disable-next-line no-unused-vars
	async loadAliexpressSalesStats({ commit, state }, reset = false) {
		commit('SET_ALIEXPRESS_SALES_STATS_LOADING', true);
		setTimeout(() => {
			commit('SET_ALIEXPRESS_SALES_STATS_LOADING', false);
			commit('SET_ALIEXPRESS_SALES_STATS_DATES', [moment().startOf('years'), moment()]);
		}, 1000);
	},
	// eslint-disable-next-line no-unused-vars
	async loadAliexpressTops({ commit, state }, reset = false) {
		commit('SET_ALIEXPRESS_TOPS_LOADING', true);
		setTimeout(() => {
			commit('SET_ALIEXPRESS_TOPS_LOADING', false);
		}, 1000);
	},
	setAliexpressSalesStatsDates({ commit }, value) {
		commit('SET_ALIEXPRESS_SALES_STATS_DATES', value);
	},
	// eslint-disable-next-line no-unused-vars
	'aliexpressSales/list': async function ({ dispatch, commit, state, getters }, { reset = false, type }) {
		commit('SET_ALIEXPRESS_SALES_LOADING', true);

		// const { query } = state.aliexpressSales;

		// let offset;

		// if (reset) offset = 0; else offset = getters['stats/aliexpressSales'].results.length;

		// let startTime; let endTime;

		// if (query.dates.length > 0) {
		// 	// eslint-disable-next-line prefer-destructuring
		// 	startTime = query.dates[0];
		// 	// eslint-disable-next-line prefer-destructuring
		// 	endTime = query.dates[1];
		// } else {
		// 	startTime = null;
		// 	endTime = null;
		// }

		// eslint-disable-next-line no-unused-vars
		let aliexpressSales = {};

		// const headers = {
		// 	Authorization: false,
		// };

		try {
			// const response = await this._vm.$http.get(
			// 	'deals', {
			// 		params: {
			// 			offset,
			// 			limit: query.limit,
			// 			search: query.search,
			// 			order_by: query.order_by,
			// 			start_time: startTime,
			// 			end_time: endTime,
			// 		},
			// 		headers,
			// 	},
			// );

			// const items = response.data.deals.results;


			// aliexpressSales = {
			// 	ok: true,
			// 	data: {
			// 		total: response.data.deals.total,
			// 		results: formatedDeals,
			// 	},
			// 	error: null,
			// };

		} catch (error) {
			// eslint-disable-next-line no-unused-vars
			aliexpressSales = {
				ok: false,
				data: [],
				error: null,
			};
		}

		// const result = {
		// 	ok: false,
		// 	state: 'complete',
		// 	total: aliexpressSales.data.total,
		// };

		// if (aliexpressSales.ok) {
		// 	result.ok = true;

		// 	dispatch('addData', { data: aliexpressSales.data, type, reset });

		// 	if (offset < aliexpressSales.data.total) result.state = 'loaded';
		// }

		return new Promise((res) => {
			const result = {
				ok: true,
				state: 'complete',
				total: [],
			};
			setTimeout(() => {
				commit('SET_ALIEXPRESS_SALES_LOADING', false);
				res(result);
			}, 1000);
		});
		// return result;
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
